// Providers
import { useProfilesStore } from '@/utils/zustand/providers/profiles-provider';

// Hooks
import useSocialProfiles from '@/utils/hooks/swr/useSocialProfiles';

// Components
import { MultiProfileItem } from '@/components/composite/SelectedProfiles/MultiSelectionProfiles/MultiProfileItem';
import { ProfilesList } from '@/components/composite/SelectedProfiles/ProfilesList';

// Types
import type { SelectedProfilesProps } from '@/components/composite/SelectedProfiles';

export function MultiSelectionProfiles({ itemsSize }: Required<SelectedProfilesProps>) {
    const { activatedSocialProfiles } = useSocialProfiles({ revalidateIfStale: false });
    const { activeSocialProfileId, activeMultiSelectionProfiles } = useProfilesStore(
        (state) => state
    );

    const profiles = activeMultiSelectionProfiles?.socialProfileIds.map((profileId) => {
        return activatedSocialProfiles.find((profile) => profile.id === profileId);
    });

    return (
        <div className="flex items-center gap-4">
            <MultiProfileItem itemsSize={itemsSize} isActive={!activeSocialProfileId} />
            <span className="h-5 min-w-[2px] bg-icoGray-300 dark:bg-icoDarkMode-beton" />
            <ProfilesList itemsSize={itemsSize} profiles={profiles} />
        </div>
    );
}
